window.addEventListener("change",(event)=>{
    if(event.target.closest('.product-info__buy-buttons')){
        const Inputid =event.target.closest('.product-info__buy-buttons').querySelector("[name='id']");
        const variantIdInputValue =Inputid.value;
        const currentVariant = findCurrentVariant(variantIdInputValue);
        const qtySelectorDiv=document.querySelector('.product-info__quantity-selector');
        if(currentVariant.available){
            if(qtySelectorDiv)
            qtySelectorDiv.classList.remove('unavailable_variant')
        }
        else{
            if(qtySelectorDiv)
            qtySelectorDiv.classList.add('unavailable_variant')
        }

        adjustColorFabric(currentVariant)
    }
})
window.addEventListener("DOMContentLoaded",(event)=>{
    const inputId=document.querySelector(".product-info__buy-buttons [name='id']");
    const currentVariant = findCurrentVariant(Number(inputId.value));
    adjustColorFabric(currentVariant)

})

window.addEventListener("click",(event)=>{
    if((event.target.closest('.tooltip_toggler') || event.target.classList.contains('tooltip_toggler') )|| (event.target.classList.contains('tooltip_wrapper') || (event.target.closest('.tooltip_wrapper') && window.innerWidth <= 768))){
            const currentTooltipWrapper = event.target.classList.contains('tooltip_wrapper')?event.target: event.target.closest('.tooltip_wrapper');

            const allTooltipWrappers=document.querySelectorAll('.tooltip_wrapper');
            allTooltipWrappers.forEach(tooltip=>{
                if(tooltip != currentTooltipWrapper)
                tooltip.classList.remove('active');
            })
            currentTooltipWrapper.classList.toggle('active')
    }
   
    if(event.target.closest('.close-tooltip-icon') || event.target.classList.contains('close-tooltip-icon')){

        const currentTooltipWrapper = event.target.closest('.tooltip_wrapper');
        currentTooltipWrapper.classList.remove('active')

    }

    if(event.target.closest('.custom__tab ') || event.target.classList.contains('custom__tab')){
    const allCustomTabs=document.querySelectorAll('.custom__tab');
    const currentTab = event.target.classList.contains('custom__tab') ? event.target : event.target.closest('.custom__tab ');

    allCustomTabs.forEach(tab=>{
        if(tab != currentTab)
        tab.classList.remove('active');
    })

    currentTab.classList.add('active')

    const currentTabData= currentTab.dataset.tab;

const allCustomTabContents=Array.from(document.querySelectorAll('.custom_tab_content'));
    const customTabContent = allCustomTabContents.find(el=> el.getAttribute('data-tab-content') === currentTabData);

    allCustomTabContents.forEach(tab=>{
        if(tab != customTabContent)
        tab.classList.remove('active');
    })
    customTabContent.classList.add('active')
    }
})



const findCurrentVariant = (variantId)=>{

return currenProduct.variants.find(v=> v.id == variantId)


}



const adjustColorFabric=(currentVariant)=>{
/*
    console.log('adjustColorFabric',currentVariant)
    console.log('productVariantsObj',productVariantsObj)*/

    const variantWithMetafields = productVariantsObj.find(v=> v.id === currentVariant.id);

    const fabricTooltipDOM = document.querySelector('.fabric_tooltip');
    const fabricTitleDOM= fabricTooltipDOM.querySelector('.tooltip_title')
    const fabricTextDOM= fabricTooltipDOM.querySelector('.tooltip_container p')


    if(variantWithMetafields){
        const currentFabricColorText=variantWithMetafields.fabric_color_text;
        const currentFabricColorTitle=variantWithMetafields.fabric_color_title;
        
        if(currentFabricColorText && currentFabricColorTitle){
           
            fabricTitleDOM.textContent=currentFabricColorTitle;
            fabricTextDOM.textContent=currentFabricColorText;



            fabricTooltipDOM.classList.remove('hidden');
        }
        else{

            


            fabricTooltipDOM.classList.add('hidden');
        }

    }
    
}